import * as React from 'react'
import {GatsbyImage, IGatsbyImageData} from 'gatsby-plugin-image'
import Typography from '@mui/material/Typography'
import Avatar from '@mui/material/Avatar'

import RevealCard from 'src/components/molecules/RevealCard'
import RenderRichText from 'src/utils/renderRichText'
import {RichTextField} from '@prismicio/types'
interface Props {
  title: {
    richText: RichTextField
  }
  height: number | undefined
  image: IGatsbyImageData | undefined
  name: {
    richText: RichTextField
  }
  body_text: {
    richText: RichTextField
  }
}

const PersonCard = ({title, name, image, height = 335, body_text}: Props) => {
  return (
    <RevealCard height={height}>
      {image && (
        <Avatar sx={{width: 94, height: 94, mb: 3, '& img': {width: '100%'}}}>
          <GatsbyImage image={image} alt="" />
        </Avatar>
      )}
      <RenderRichText
        field={name}
        components={{
          heading6: ({children}) => (
            <Typography variant="h6">{children}</Typography>
          ),
        }}
      />
      <RenderRichText
        field={title}
        components={{
          heading6: ({children}) => (
            <Typography variant="subtitle2">{children}</Typography>
          ),
        }}
      />
      <RenderRichText field={body_text} />
    </RevealCard>
  )
}

export default PersonCard
